/**
 * 子账号管理国际化资源
 */
const prefixCls = 'web.subAccount.';

export const localesSubAccount = {
  // 标题和说明
  [prefixCls + 'title']: {
    zh_CN: '子账号管理',
    en_GB: 'Sub Account Management',
  },
  [prefixCls + 'description']: {
    zh_CN: '管理系统中的子账号及其权限',
    en_GB: 'Manage system sub-accounts and their permissions',
  },

  // 表格列标题
  [prefixCls + 'table.column.name']: {
    zh_CN: '名称',
    en_GB: 'Name',
  },
  [prefixCls + 'table.column.site']: {
    zh_CN: '站点',
    en_GB: 'Site',
  },
  [prefixCls + 'table.column.company']: {
    zh_CN: '公司',
    en_GB: 'Company',
  },
  [prefixCls + 'table.column.noonAccount']: {
    zh_CN: 'noon账号',
    en_GB: 'Noon Account',
  },
  [prefixCls + 'table.column.linkQuota']: {
    zh_CN: '创建链接额度',
    en_GB: 'Link Creation Quota',
  },
  [prefixCls + 'table.column.expiryDate']: {
    zh_CN: '过期时间',
    en_GB: 'Expiry Date',
  },
  [prefixCls + 'table.column.createdTime']: {
    zh_CN: '创建时间',
    en_GB: 'Created Time',
  },
  [prefixCls + 'table.column.status']: {
    zh_CN: '状态',
    en_GB: 'Status',
  },
  [prefixCls + 'table.column.actions']: {
    zh_CN: '操作',
    en_GB: 'Actions',
  },

  // 筛选和搜索
  [prefixCls + 'filter.searchPlaceholder']: {
    zh_CN: '搜索账号名称',
    en_GB: 'Search account name',
  },

  // 操作按钮
  [prefixCls + 'action.createAccount']: {
    zh_CN: '创建子账号',
    en_GB: 'Create Sub Account',
  },
  [prefixCls + 'action.changePassword']: {
    zh_CN: '修改密码',
    en_GB: 'Change Password',
  },

  // 状态和标签
  [prefixCls + 'status.premium']: {
    zh_CN: '尊贵版',
    en_GB: 'Premium',
  },
  [prefixCls + 'tag.mainAccount']: {
    zh_CN: '主账号',
    en_GB: 'Main Account',
  },
  [prefixCls + 'tag.authorized']: {
    zh_CN: '已授权',
    en_GB: 'Authorized',
  },

  // 提示和确认
  [prefixCls + 'confirm.deleteAccount']: {
    zh_CN: '确定要删除此子账号吗？此操作不可恢复。',
    en_GB:
      'Are you sure you want to delete this sub-account? This action cannot be undone.',
  },

  // 表单字段
  [prefixCls + 'form.name']: {
    zh_CN: '账号名称',
    en_GB: 'Account Name',
  },
  [prefixCls + 'form.site']: {
    zh_CN: '站点',
    en_GB: 'Site',
  },
  [prefixCls + 'form.company']: {
    zh_CN: '公司名称',
    en_GB: 'Company Name',
  },
  [prefixCls + 'form.noonAccount']: {
    zh_CN: 'Noon账号',
    en_GB: 'Noon Account',
  },
  [prefixCls + 'form.linkTotal']: {
    zh_CN: '创建链接额度',
    en_GB: 'Link Creation Quota',
  },
  [prefixCls + 'form.expiryDate']: {
    zh_CN: '过期时间',
    en_GB: 'Expiry Date',
  },
  [prefixCls + 'form.password']: {
    zh_CN: '密码',
    en_GB: 'Password',
  },
  [prefixCls + 'form.confirmPassword']: {
    zh_CN: '确认密码',
    en_GB: 'Confirm Password',
  },

  // 错误信息
  [prefixCls + 'error.fetchFailed']: {
    zh_CN: '获取子账号列表失败',
    en_GB: 'Failed to fetch sub-account list',
  },
  [prefixCls + 'error.createFailed']: {
    zh_CN: '创建子账号失败',
    en_GB: 'Failed to create sub-account',
  },
  [prefixCls + 'error.updateFailed']: {
    zh_CN: '更新子账号信息失败',
    en_GB: 'Failed to update sub-account information',
  },
  [prefixCls + 'error.deleteFailed']: {
    zh_CN: '删除子账号失败',
    en_GB: 'Failed to delete sub-account',
  },
  [prefixCls + 'error.changePasswordFailed']: {
    zh_CN: '修改密码失败',
    en_GB: 'Failed to change password',
  },
  [prefixCls + 'error.passwordNotMatch']: {
    zh_CN: '两次输入的密码不一致',
    en_GB: 'The two passwords do not match',
  },
};
